/** @module ProductSpec/SizeChart/StyleSizeChartMixin */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/store/Memory",
	"csi/def",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/form/Widget",
	"csi/locale",
	"csi/store/_base",
	"csi/store/Names",
	"csi/xml",
	"csi/xml/Query"
], function(declare, lang, Memory, def, Action, ViewRef, Field, Relationship, Widget, locale, csiStore, Names, xml, Query) {

	var _StyleSizeCharts = declare(Names, {
		_processResultNode: function(/*Node*/node, /*Cache*/cache) {
			//S10146 summary: add Style Name before Style Size Chart Name
			var style = cache.getNode(node.__Parent__);
			var item = {$: node.$URL, Name: locale.getNodeConfiguredName(style, cache) + " " + locale.getNodeConfiguredName(node, cache), node: node};
			return item;
		}
	});

	return declare(Widget, {

		FIELD_STYLE_SIZE_CHARTS: "StyleSizeCharts",

		/**
		 * Gets Size Charts Field
		 */
		getFieldSizeCharts: function() {
			var params = {defaultAll: true};
			return this.defView.addField(lang.mixin(new Field(), {
				m_label: this.FIELD_STYLE_SIZE_CHARTS,
				m_typeControl: def.FIELD_MULTI_SELECT,
				m_bRequired: true,
				widgetParams: params,
				idParameter: "SizeCharts",
				m_relationship: lang.mixin(new Relationship(), {
					m_url: this.getViewNode().__Parent__,
					m_id: this.FIELD_STYLE_SIZE_CHARTS,
					m_depPaths: ["Child:__Parent__"],
					m_query: new Query().Attr("State", xml.OP_EQUALS, "Revision.State:DRAFT", "Child:LatestRevision")
				})
			}));
		},

		/**
		 * Gets Field Style Size Chart Store
		 * @param {Field} field
		 */
		getFieldStyleSizeChartStore: function(field) {
			// special store to return Style Size Charts
			// add dependency path to get the parent Style
			var ctx = this.getContext();
			var storeOptions = csiStore.namesOptionsByRelationship(ctx, field.m_relationship, null, {customOperation: true});
			storeOptions.request.addDependencyPaths(field.m_relationship.m_depPaths);
			storeOptions.action = lang.mixin(new Action(), {
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: "StyleSizeCharts",
					m_url: this.getViewNode().__Parent__
				}),
				m_fixedQuery: new Query().Attr("State", xml.OP_EQUALS, "Revision.State:DRAFT", "Child:LatestRevision")
			});
			return new _StyleSizeCharts(storeOptions);
		}
	});
});